module.exports = __webpack_public_path__ + "static/media/phone.876c35e0.svg";